import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useApp } from '../context/AppContext';

export default function AuthCallback() {
  const { API, setUser } = useApp();
  const nav = useNavigate();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = window.location.hash;
    const sid = new URLSearchParams(hash.replace(/^#/, '')).get('session_id');
    if (!sid) { nav('/'); return; }
    (async () => {
      try {
        const r = await axios.post(`${API}/auth/google/session`, { session_id: sid }, { withCredentials: true });
        setUser(r.data);
        // clear hash and go home
        window.history.replaceState(null, '', '/');
        nav('/');
      } catch {
        nav('/auth');
      }
    })();
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center bg-black text-[#00FFD1] font-mono-cyber">
      &gt; establishing_session…
    </div>
  );
}
